// extracted by mini-css-extract-plugin
export default {"themeHeal":"#003da5","themeBlueShield":"#0171bc"};